import api from './api';

export const taskRelationService = {
  getByTaskId: async (taskId) => {
    const response = await api.get(`/task-relations/task/${taskId}`);
    return response.data;
  },

  getByProjectId: async (projectId) => {
    const response = await api.get(`/task-relations/project/${projectId}`);
    return response.data;
  },

  create: async ({ sourceTaskId, targetTaskId, type }) => {
    const response = await api.post('/task-relations', {
      sourceTaskId,
      targetTaskId,
      type,
    });
    return response.data;
  },

  delete: async (relationId) => {
    const response = await api.delete(`/task-relations/${relationId}`);
    return response.data;
  },

  checkCircular: async (sourceTaskId, targetTaskId) => {
    const response = await api.get('/task-relations/check-circular', {
      params: { sourceTaskId, targetTaskId },
    });
    return response.data;
  },
};

export default taskRelationService;
